import React, { useState, useEffect } from 'react';
import './CookiePreferences.css';

const CookiePreferences = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [preferences, setPreferences] = useState({
    necessary: true, // Always true, cannot be disabled
    analytics: false,
    functionality: false,
    advertising: false
  });

  useEffect(() => {
    // Check if user has already set preferences
    const savedPreferences = localStorage.getItem('cookiePreferences');
    if (!savedPreferences) {
      setIsVisible(true);
    } else {
      setPreferences(JSON.parse(savedPreferences));
    }

    // Global function to show preferences (called from footer)
    window.showCookiePreferences = () => {
      setIsVisible(true);
    };

    return () => {
      delete window.showCookiePreferences;
    };
  }, []);

  const handlePreferenceChange = (type) => {
    if (type === 'necessary') return; // Cannot disable necessary cookies
    
    setPreferences(prev => ({
      ...prev,
      [type]: !prev[type]
    }));
  };

  const handleAcceptAll = () => {
    const allAccepted = {
      necessary: true,
      analytics: true,
      functionality: true,
      advertising: true
    };
    setPreferences(allAccepted);
    savePreferences(allAccepted);
    setIsVisible(false);
  };

  const handleAcceptSelected = () => {
    savePreferences(preferences);
    setIsVisible(false);
  };

  const handleRejectAll = () => {
    const onlyNecessary = {
      necessary: true,
      analytics: false,
      functionality: false,
      advertising: false
    };
    setPreferences(onlyNecessary);
    savePreferences(onlyNecessary);
    setIsVisible(false);
  };

  const savePreferences = (prefs) => {
    localStorage.setItem('cookiePreferences', JSON.stringify(prefs));
    localStorage.setItem('cookieConsentDate', new Date().toISOString());
    
    // Here you would typically initialize/disable analytics based on preferences
    if (prefs.analytics && window.gtag) {
      window.gtag('consent', 'update', {
        'analytics_storage': 'granted'
      });
    }
  };

  if (!isVisible) return null;

  return (
    <div className="cookie-preferences-overlay">
      <div className="cookie-preferences-modal">
        <div className="cookie-preferences-header">
          <h3>Cookie Preferences</h3>
          <button 
            className="close-btn"
            onClick={() => setIsVisible(false)}
            aria-label="Close"
          >
            ×
          </button>
        </div>
        
        <div className="cookie-preferences-content">
          <p>
            We only use essential cookies necessary for basic website functionality like form submissions and remembering your cookie preferences. We do not track or analyze your browsing.
          </p>
          
          <div className="cookie-categories">
            <div className="cookie-category">
              <div className="category-header">
                <label className="cookie-label">
                  <input
                    type="checkbox"
                    checked={preferences.necessary}
                    disabled
                    aria-label="Necessary cookies - always enabled"
                  />
                  <span className="category-title">Strictly Necessary Cookies</span>
                  <span className="required-badge">Required</span>
                </label>
              </div>
              <p className="category-description">
                These cookies are essential for the website to function and cannot be disabled.
              </p>
            </div>

            <div className="cookie-info">
              <p><strong>Note:</strong> Since we only use essential cookies for basic website functionality, there are no optional cookies to manage. All cookies used by this website are necessary for it to work properly.</p>
              <p>The only optional cookies are set by YouTube when you play embedded videos, which are managed by YouTube directly.</p>
            </div>
          </div>
        </div>
        
        <div className="cookie-preferences-actions">
          <button className="btn-primary cookie-close-notice-btn" onClick={handleAcceptAll}>
            Understand - Close This Notice
          </button>
        </div>
        
        <div className="cookie-preferences-footer">
          <p>
            For more information, see our <a href="/cookie-policy" target="_blank">Cookie Policy</a> and <a href="/privacy-policy" target="_blank">Privacy Policy</a>.
          </p>
        </div>
      </div>
    </div>
  );
};

export default CookiePreferences;
